import React from "react";
import Seo from "../components/Seo";
import HeroSection from "../components/home/HeroSection";
import TeamSection from "../components/home/TeamSection";
import AgentGuide from "../components/home/AgentGuide";
import CommunitiesSection from "../components/home/CommunitiesSection";
import { IntroStrip, HomeCTA } from "../components/home/HomeExtras";

const Home = () => (
  <div>
    <Seo
      title="Roger Minner Realtor | Kennett Square, PA Real Estate Agent - Approved Military and Government relocation specialist"
      description="Roger Minner helps buyers and sellers navigate the Kennett Square, West Chester, PA real estate market. Serves Chester County and Delaware County with local expertise and hands-on guidance. Approved Military and Government relocation specialist."
    />
    <HeroSection />
    <IntroStrip />
    <TeamSection />
    <AgentGuide />
    <CommunitiesSection />
    <HomeCTA />
  </div>
);

export default Home;
